import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';

import BillingInvoice from 'component/view/Settings/BillingInvoice';

import { findCachedListItem, requireObjectOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/billing/invoice/$invoiceId')({
  component: BillingInvoice,
  beforeLoad: async ({ context, params }) => {
    const invoiceId = Number(params.invoiceId);
    const options = RocketAPI.billing.getFindBillingInvoiceQueryOptions(invoiceId);

    await requireObjectOperation({
      context,
      options,
      redirectTo: '/n/settings/account-and-security',
      cachedItem: findCachedListItem(
        context.queryClient,
        ['/v1/billing/invoices'],
        data => (data as { result?: { id?: number }[] } | undefined)?.result,
        invoice => invoice.id === invoiceId
      ),
      onNotFound: () => {
        throw redirect({
          to: '/n/settings/billing',
          replace: true,
          state: prev => ({ ...prev, errorSnackbar: t('settings.billing.invoice_not_found') }),
        });
      },
    });
  },
});
